// Generated by tools/gen-backend-hooks.ts — do not edit by hand.
// One hook per endpoint in backend/customerInbox/.

import { makeBackendHook } from './_client'

export type { BackendQuery, TriggerOptions } from './_client'

/** POST /api/rpc/customerInbox/addSenderContact */
export const useAddSenderContact = makeBackendHook('customerInbox', 'addSenderContact')

/** POST /api/rpc/customerInbox/bulkConversationStatus */
export const useBulkConversationStatus = makeBackendHook('customerInbox', 'bulkConversationStatus')

/** POST /api/rpc/customerInbox/generateReply */
export const useGenerateReply = makeBackendHook('customerInbox', 'generateReply')

/** POST /api/rpc/customerInbox/getConversation */
export const useGetConversation = makeBackendHook('customerInbox', 'getConversation')

/** POST /api/rpc/customerInbox/getInbox */
export const useGetInbox = makeBackendHook('customerInbox', 'getInbox')

/** POST /api/rpc/customerInbox/resolveReplySend */
export const useResolveReplySend = makeBackendHook('customerInbox', 'resolveReplySend')

/** POST /api/rpc/customerInbox/saveInboxSettings */
export const useSaveInboxSettings = makeBackendHook('customerInbox', 'saveInboxSettings')

/** POST /api/rpc/customerInbox/saveReplyDraft */
export const useSaveReplyDraft = makeBackendHook('customerInbox', 'saveReplyDraft')

/** POST /api/rpc/customerInbox/sendReply */
export const useSendReply = makeBackendHook('customerInbox', 'sendReply')

/** POST /api/rpc/customerInbox/setConversationStatus */
export const useSetConversationStatus = makeBackendHook('customerInbox', 'setConversationStatus')

/** POST /api/rpc/customerInbox/syncMailbox */
export const useSyncMailbox = makeBackendHook('customerInbox', 'syncMailbox')
